<template>
  <div class="footer-bar">
    <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
  </div>
</template>

<script>
export default {
  name: 'FooterBar',
  data() {
    return {
      btnList: [
        {
          isFill: true
        },
        {
          btnContent: '清除对话',
          click: () => {
            return this.onClearMessages()
          },
          type: 'text',
          icon: 'icon-clear'
        }
      ]
    }
  },
  methods: {
    onClearMessages() {
      this.$emit('clearMessages')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('footer-bar', (
    --clear-btn-color: var(--base-color-text-regular),
    --clear-btn-hover-color: var(--base-color-white)
), (
    --clear-btn-color: var(--base-color-white),
    --clear-btn-hover-color: var(--base-color-notice)
));
.footer-bar {
  height: var(--base-size-32);

  .btn-list-style {
    /deep/ {
      .el-button {
        color: var(--clear-btn-color);

        &:hover,
        &:active {
          color: var(--clear-btn-hover-color);
        }
      }
    }
  }
}
</style>
